export default __webpack_public_path__ + "static/media/Sync.53b320f7.svg";